<div mode="card" >
 
    <div class="ItemSearch">
      <h3>Claim Assignment History</h3>
      <span (click)="close()" class="close">
        <img src="https://cdn.elitehw.com/images/cross.webp" />
      </span>
    </div>
    <div class="flex">
        <div class="table">
            <table mat-table [dataSource]="data?.claimHistory?.data">
     
              <ng-container matColumnDef="assignee">
                <th mat-header-cell *matHeaderCellDef>Assignee Name</th>
                <td mat-cell *matCellDef="let element">
                  {{ commonService.getFullName(element?.assignedTo?.firstName, element?.assignedTo?.lastName) }}
                </td>
              </ng-container>
        
    
              <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef>Assigned Claim Role</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.assignedPosition }}
                </td>
              </ng-container>
        
          
              <ng-container matColumnDef="assignedBy">
                <th mat-header-cell *matHeaderCellDef>Assigned By</th>
                <td mat-cell *matCellDef="let element">
                    {{ commonService.getFullName(element?.assignedBy?.firstName, element?.assignedBy?.lastName) }}
                </td>
              </ng-container>
        
           
              <ng-container matColumnDef="assignedOn">
                <th mat-header-cell *matHeaderCellDef>Assigned On</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.createdAt | date : "MMM-dd-YYYY h:mm a" }}
                </td>
              </ng-container>
   
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <div
              *ngIf="!data?.claimHistory?.data?.length"
              style="padding: 10px 0; text-align: center"
            >
              No data found.
            </div>
          </div>
    </div>
</div>